import { checkObjectProperties, isString } from "../checkObjectProperties";

export type TextSearchCriteria = {
  key: string;
  text: string;
  match: Match;
};

export const isTextSearchCriteria = (obj: unknown): obj is TextSearchCriteria => {
  return checkObjectProperties(obj, {
    key: isString,
    text: isString,
    match: isMatch,
  });
};

export const MATCH = {
  PARTIAL: 0,
  EXACT: 1,
  FORWARD: 2,
  BACKWARD: 3,
  REGEXP: 4,
} as const;

export type Match = (typeof MATCH)[keyof typeof MATCH];

export const MATCH_STRING = {
  0: "部分一致",
  1: "完全一致",
  2: "前方一致",
  3: "後方一致",
  4: "正規表現",
} as const;

const isMatch = (n: unknown): n is Match => {
  return typeof n === "number" && Object.values<typeof n>(MATCH).includes(n);
};
